import { apiSlice } from "services/apiSlice";

export const invoiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createInvoice: builder.mutation({
      query: (invoiceData) => ({
        url: "invoices",
        method: "POST",
        body: invoiceData,
      }),
      invalidatesTags: ["invoices"],
    }),
    createInvoiceDraft: builder.mutation({
      query: (invoiceData) => ({
        url: "invoices/draft",
        method: "POST",
        body: invoiceData,
      }),
      invalidatesTags: ["invoices"],
    }),

    getInvoices: builder.query({
      query: (companyId) => `invoices/by-company/${companyId}`,
      providesTags: ["invoices"],
    }),
    getInvoiceById: builder.query({
      query: (id) => `invoices/${id}`,
      providesTags: (result, error, id) => [{ type: "invoices", id }],
    }),
    updateInvoiceStatus: builder.mutation({
      query: ({ id, invoiceStatus }) => ({
        url: `invoices/${id}`,
        method: "PATCH",
        body: { invoiceStatus },
      }),
      invalidatesTags: ["invoices"],
    }),
    updateInvoice: builder.mutation({
      query: ({ id, ...fields }) => {
        console.log("🪵 ID envoyé à l'API :", id); // <= LOG ici
        console.log("🪵 ID envoyé àfields:", fields); // <= LOG ici
        return {
          url: `invoices/${id}`,
          method: "PATCH",
          body: fields,
        };
      },
      invalidatesTags: ["invoices"],
    }),
    getNextInvoiceNumber: builder.query({
      query: (id) => `invoices/next-number/${id}`,
    }),
    getInvoiceByCompanyAndId: builder.query({
      query: ({ companyId, invoiceId }) =>
        `invoices/by-company/${companyId}/invoiceId/${invoiceId}`,
    }),
    getInvoicesByClient: builder.query({
      query: ({ companyId, clientId }) => ({
        url: `invoices/by-company/${companyId}/by-client/${clientId}`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateInvoiceMutation,
  useGetInvoicesQuery,
  useUpdateInvoiceStatusMutation,
  useUpdateInvoiceMutation,
  useGetNextInvoiceNumberQuery,
  useLazyGetInvoiceByIdQuery,
  useGetInvoiceByIdQuery, // ← à ajouter ici
  useGetInvoiceByCompanyAndIdQuery,
  useGetInvoicesByClientQuery,
  useCreateInvoiceDraftMutation
} = invoiceApi;
